import {
	Button,
	Dialog,
	Stack,
	Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from "react-redux";
import { removeAuthorizationRequest } from "../../../state/actions/chats";
import { setButtonLoader } from "../../../state/actions/loader";
import { MessageTypeConstants } from "../../../services/bot/Message";
import { setTabState } from "../../../state/actions/tabStack";
import { processSendMessage } from "../../../services/bot/conversation/SendMessage";

const MainButton = styled(Button)(() => ({
	border: 'none',
	padding: '7px 45px',
	borderRadius: 20,
	textTransform: 'inherit',
	'&:hover': { border: 'none' },
}));

export const CancelButton = styled(MainButton)(() => ({
	backgroundColor: '#e0e8ff',
	color: '#638dff',
	border: 'none',
	fontFamily: 'SF Pro Text Bold',
	fontSize: 14,
	boxShadow: 'none',
	'&:hover': { backgroundColor: '#eef2ff' },
	'&:focus': {
		boxShadow: '0 0 6px 0 rgba(99, 141, 255, 0.6)',
		backgroundColor: '#eef2ff',
	},
	'&:disabled': {
		backgroundColor: '#e8ecf8',
		color: '#aeb8d6',
		border: 'none',
	},
}));

export const ConfirmButton = styled(MainButton)(() => ({
	backgroundColor: '#638dff',
	color: '#FFFFFF',
	fontFamily: 'SF Pro Text Bold',
	fontSize: 14,
	boxShadow: 'none',
	'&:hover': { backgroundColor: '#4c71d6' },
	'&:focus': { boxShadow: '0 0 6px 0 #638dff !important' },
	'&:disabled': {
		backgroundColor: '#aeb8d6',
		color: '#e8ecf8',
	},
}));


const ConfirmDeleteTabClose = ({
	showModal,
	confirmDeleteModal,
	handleConfirmDelete,
	handleCancelDelete,
}) => {
	const buttonLoader = useSelector((state) => state.loader.buttonLoader);
	const dispatch = useDispatch();

	const handleCancelDeleteInModal = () => {
		dispatch(removeAuthorizationRequest());
	};

	const handleConfirmDeleteInModal = () => {
		const { controlId = null, tabId = null } = confirmDeleteModal;

		const responseChat = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_AUTHORIZATION_REQUEST_RESPONSE,
			message: {
				controlId,
				tabId,
				action: "confirm",
				content: null,
				oldContent: null,
			},
		};
		dispatch(setTabState(false))
		processSendMessage(responseChat);
		dispatch(setButtonLoader(true));
		dispatch(removeAuthorizationRequest());
	};

	return (
		<Dialog
			open={showModal}
			disableEscapeKeyDown
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<Stack justifyContent={"center"} alignItems={"center"} sx={{ p: 2 }}>
				<Typography variant="h6" fontWeight={"600"} sx={{ mb: 2 }}> {confirmDeleteModal.dialogTitle || ""}</Typography>
				<Stack justifyContent={"center"} alignItems={"center"} sx={{ mb: 3 }}>
					<Typography textAlign={"center"} sx={{ color: "#44485A99" }}>
						{confirmDeleteModal.dialogMessage ? confirmDeleteModal.dialogMessage : confirmDeleteModal.message}
					</Typography>
				</Stack>

				<Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} gap={2}>
					<CancelButton color='primary' variant='outlined' label={"Cancel"} onClick={() => handleCancelDelete ? handleCancelDelete() : handleCancelDeleteInModal()} >
						{confirmDeleteModal?.dialogCancel || "Cancel"}
					</CancelButton>
					<ConfirmButton variant='outlined' onClick={() => handleConfirmDelete ? handleConfirmDelete() : handleConfirmDeleteInModal()} color='primary' >
						{buttonLoader ? <CircularProgress size={14} sx={{ marginBlock: "5px", marginInline: "20px", color: "#ffff" }} /> : confirmDeleteModal.dialogConfirm || "Confirm"}
					</ConfirmButton>
				</Stack>
			</Stack>
		</Dialog>
	);
};

export default ConfirmDeleteTabClose;
